import img1 from "../Images/blog_1.png";
import img2 from "../Images/blog_2.png";
import img3 from "../Images/blog_3.png";
import img4 from "../Images/blog_4.png";
import img5 from "../Images/blog_5.png";
import img6 from "../Images/blog_6.png";
import img7 from "../Images/blog_7.png";

export default [
    {
        index: '/blog7',
        img: img7,
        title: 'VS-CODE for Web Development',
        para: 'Visual Studio Code is a source-code editor made by Microsoft for Windows, Linux, and macOS. Features include support for debugging, syntax highlighting, intelligent code completion, snippets, code refactoring, and embedded Git. This is Free to use....'
    },
    {
        index: '/blog6',
        img: img6,
        title: 'Free Certified by Coursera',
        para: 'If you are student, Coursera giving you a chance to learn from big developers/Professors from most prestigious international companies, universities like Google, Microsoft, etc. If you are student and want to get certified course/specialization from Coursera just follow these steps....'
    },
    {
        index: '/blog5',
        img: img5,
        title: '5 Best DSA Course Free/Paid??',
        para: 'DSA means Data Structure and Algorithms. Data structure and Algorithm (DSA) is applied in all disciplines of software development. DSA is the building block of the software development process. It is not limited to a single programming language.Although programming languages evolve or get dormant over time, DSA is incorporated into all of these languages...'
    },
    {
        index: '/blog4',
        img: img4,
        title: 'How to get any Udemy Course FREE!!',
        para: 'Udemy is the the platform from where you can get, Best Course at genuine price. Course are given by Best international Instructors. Price of course varies time to time. You may get particular course at ₹450 or may be ₹1000+ To visit Udemy. Udemy offers some course at Free.With Each paid course you will get a certificate of completion after Tests, Quiz’s Assignment...'
    },
    {
        index: '/blog3',
        img: img2,
        title: 'Roadmap for Android Development',
        para: 'To start with Android Development you must be aware of Prerequisites for Android Development. First of all you must decide the language which will you use in development and XML(Syntax). For languages we have two choices...'
    },
    {
        index: '/blog2',
        img: img3,
        title: 'How to download Python3 in 2021??',
        para: 'Python is an interpreted high-level general-purpose programming language. Python’s design philosophy emphasizes code readability with its notable use of significant indentation. Follow these steps to download and install Python in your PC/Laptop...'
    },
    {
        index: '/blog1',
        img: img1,
        title: 'No Module named PyAudio',
        para: 'PyAudio is a set of Python bindings for PortAudio, a cross-platform C++ library interfacing with audio drivers. I faced issue while installing it and I have followed these steps and this works for me.I try to explain you simply.You can use this method for any Library not Just PyAudio step will be same...'
    }
];